module.exports = __webpack_public_path__ + "img/52114115_L.78dc2da6.png";